import { useContext, useEffect } from "react"
import { useShallow } from "zustand/react/shallow"

import { ICompaniesUI } from "./_types"
import { CompaniesUI } from "./_interface"

import { useInput } from "hooks/useInput"
import { useDebounce } from "hooks/useDebounce"

import { useCompanies } from "store/companies"

import { CardModeType } from "components/smart/common.types"
import { CardCompanyContainer, ICardCompanyContainer } from "components/smart/card_company"

import { NotificationContext, notifyOpen } from "components/ui/notification/notification.provider"


/** Контрагенты - Контейнер */
export const CompaniesContainer = () => {
    const notify = useContext(NotificationContext)

    const txtSearch = useInput<string>('')
    const currentPageNumber = useInput<number>(1)

    const modalCardCompany = useInput<ICardCompanyContainer>({ isOpen: false })


    /** Хранилище - Контрагенты */
    const { 
        errors, companiesStatistics, isLoadingCompanies, 
        isReloadCompanies, companiesItems, totalCount, pageSize, 
        getCompanies, clearCompaniesState 
    } = useCompanies(useShallow((state) => ({
        errors: state.error,
        companiesStatistics: state.companiesStatistics,

        isLoadingCompanies: state.companies.isLoading,
        isReloadCompanies: state.companies.isReload,
        
        getCompanies: state.getCompanies,
        companiesItems: state.companies.items,
        totalCount: state.companies.totalCount,
        pageSize: state.companies.pageSize,

        clearCompaniesState: state.clearCompaniesState
    })))


    useEffect(() => {
        return (() => {
            clearCompaniesState()

            txtSearch.setValue('')
            currentPageNumber.setValue(1)
        })
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => { // Загрузка данных
        loadDataList(txtSearch.value)
    }, [currentPageNumber.value, isReloadCompanies]) // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => { // Вывод ошибок
        if (errors?.message) return notifyOpen(errors?.message, errors?.type, 2000, notify)
    }, [errors?.message]) // eslint-disable-line react-hooks/exhaustive-deps


    /** Загрузка основных данных */
    const loadDataList = (search?: string) => {
        getCompanies(currentPageNumber.value, search || '')
    }

    /** Открытие/закрытие анкеты контрагента */
    const handlerOpenCardCompany = (isOpen: boolean, cardMode: CardModeType, cardID?: string) => {
        modalCardCompany.setValue({
            isOpen, cardMode, cardID,
            handlerButtonCancel() { modalCardCompany.setValue({ isOpen: false }) },
            handlerButtonOk() {
                modalCardCompany.setValue({ isOpen: false })
                loadDataList(txtSearch.value)
            }
        })
    }

    /** Запуск загрузки основного списка через полторы секунды */
    const debounceSearch = useDebounce(loadDataList, 1500)
    /** Поле поиска - изменение и запуск загрузки */
    const txtSearchOnChange = (value: string) => {
        txtSearch.setValue(value)
        debounceSearch(value)
    }


    /** Свойства передаваемые в компоненту */
    const propsToUI: ICompaniesUI = {
        txtSearch, isLoadingCompanies, companiesStatistics,
        companiesItems, totalCount, pageSize, currentPageNumber,
        loadDataList, txtSearchOnChange, handlerOpenCardCompany,
    }

    return <>
        <CompaniesUI {...propsToUI} />
        <CardCompanyContainer {...modalCardCompany.value} />
    </>
}